import React from 'react'
import styles from './styles.css'
import sendMessage from '../Actions/sendMessage'
import useMutate from 'apollo-hooks/lib/useMutate'
import useUserId from 'App/hooks/useUserId'
import useMessage from 'App/hooks/useMessage'
import useEffect from 'App/hooks/useEffect'
import useRef from 'App/hooks/useRef'

export default function Input({text, setText, conversationId, refetchMessages}) {
  const mutate = useMutate()
  const userId = useUserId()
  const showMessage = useMessage()

  const handleKeyDown = async event => {
    if (event.key !== 'Enter') return
    const theText = text
    try {
      setText('')
      await sendMessage({mutate, userId, text: theText, conversationId})
    } catch (error) {
      setText(theText)
      showMessage(error)
    }
  }

  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.focus()
  }, [conversationId])

  return (
    <div className={styles.container}>
      <input
        type="text"
        placeholder="Enviar un mensaje"
        value={text}
        onChange={event => setText(event.target.value)}
        onKeyDown={handleKeyDown}
        ref={inputRef}
      />
    </div>
  )
}
